module.exports = __webpack_public_path__ + "img/caffemanifesto.211b57b7.jpg";